import { getCS as getFromCookie } from '@/common/service/storage/CookieStorage';
import { CookiesTypes } from '@/common/service/storage/Storage.domain';

export const CURRENCY = 'USD';
export const ANALYTICS_IS_DISABLED = Boolean(
    parseInt(`${getFromCookie(CookiesTypes.CS_DISABLE_ANALYTICS, '0')}`, 10)
);
